/**
 * Map configuration constants
 */

export const MAP_CONFIG = {
  DEFAULT_ZOOM: 12,
  // Geographic center of the contiguous United States (near Lebanon, Kansas)
  DEFAULT_CENTER: { lat: 39.567204, lng: -98.1398953 },
  SHOW_MAP_TYPE_SELECTOR: false,
  DEFAULT_MAP_TYPE: 'hybrid' as 'roadmap' | 'satellite' | 'hybrid' | 'terrain',
  TEXT_COLOR: 'white' as 'white' | 'black'
};